/**
 * useAuditLogs Hook
 *
 * React Query hook for fetching audit logs with cursor-based pagination.
 */

import { useQuery } from "@tanstack/react-query";
import { auditLogService } from "../../../api/audit-log.service";
import type { ListAuditLogsResponse } from "../../../api/audit-log.service";
import type { AuditLogListQuery } from "../../../types/audit-log.types";
import type { ApiPagination } from "../../../types/api.types";

export const AUDIT_LOGS_QUERY_KEY = "auditLogs";

const DEFAULT_PAGINATION: ApiPagination = {
  total: 0,
  count: 0,
  limit: 20,
  hasMore: false,
};

export function useAuditLogs(tenantId: string, query?: AuditLogListQuery) {
  const result = useQuery<ListAuditLogsResponse, Error>({
    queryKey: [AUDIT_LOGS_QUERY_KEY, tenantId, query],
    queryFn: () => auditLogService.listAuditLogs(tenantId, query),
    enabled: !!tenantId,
    staleTime: 30000,
  });

  return {
    ...result,
    auditLogs: result.data?.items ?? [],
    pagination: result.data?.pagination ?? DEFAULT_PAGINATION,
  };
}
